import SafeAreaProps from './types';

export default ({children}: SafeAreaProps) => children;
